import { Component, OnInit } from "@angular/core";
import { ApiCallingService } from "../../services/api-calling.service";
import { ConfigApi } from "../../config-api";
import { ToastrService } from "ngx-toastr";
import { Globals } from "../../common/global";
import { Router } from "@angular/router";
import { HttpParams } from "@angular/common/http";

@Component({
  selector: "app-my-assigned-advance-booking",
  templateUrl: "./my-assigned-advance-booking.component.html",
  styleUrls: ["./my-assigned-advance-booking.component.css"],
})
export class MyAssignedAdvanceBookingComponent implements OnInit {
  bookings: any[] = [];
  page = 0;
  pageSize = 10;
  totalcount = 0;
  currency = "";

  constructor(
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService,
    public globals: Globals,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getBookings();
    this.currency = this.globals.getUser().operator_id.countryObject.currency;
  }

  getBookings() {
    const employeeId = this.globals.user.employee_id;
    const pageIndex = this.page > 0 ? this.page - 1 : 0;
    let params = new HttpParams()
      .set("employee_id", employeeId)
      .set("page", pageIndex.toString())
      .set("pageSize", this.pageSize.toString());

    this.apiCallingService
      .callAPI(
        params,
        "GET",
        ConfigApi.URLS.EMPLOYEE_ADVANCE_BOOKING_LIST + `?${params.toString()}`
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.bookings = res.data;
            this.totalcount = res?.total || 0;
          }
        },
        (error) => {
          console.error("Error fetching booking list:", error);
        }
      );
  }

  getStatusClass(status: string): string {
    switch (status.toLowerCase()) {
      case "completed":
        return "success";
      case "cancelled":
        return "danger";
      case "cancel_request":
        return "danger";
      case "expired":
        return "danger";
      case "upcoming":
        return "info";
      case "active":
        return "warning";
      case "refund_request":
        return "warning";
      case "returned":
        return "info";
      case "completed":
        return "info";
      case "refunded":
        return "info";

      default:
        return "warning";
    }
  }

  loadPage(page: number): void {
    this.page = page;
    this.getBookings();
  }
}
